import CompanySettingsTab from 'src/components/pages/Company/CompanyPage/CompanySettingsTab/CompanySettingsTab';

export default CompanySettingsTab;
